"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Holder = void 0;
/**
 * Subscribable single-value container, suitable for connecting to via
 * `useSyncExternalStore()`.
 */
class Holder {
    constructor(name) {
        this.name = name;
        this.value = null;
        this.listeners = new Set();
        this.version = 0;
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => {
                this.listeners.delete(listener);
            };
        };
        this.getSnapshot = () => this.version;
    }
    get() {
        if (!this.value) {
            throw new Error(`${this.name} accessed before it was set`);
        }
        return this.value;
    }
    peek() {
        return this.value;
    }
    set(value) {
        this.value = value;
        this.bumpVersion();
    }
    clear() {
        this.value = null;
        this.bumpVersion();
    }
    bumpVersion() {
        this.version++;
        for (const listener of this.listeners) {
            listener();
        }
    }
}
exports.Holder = Holder;
